module.exports = __webpack_public_path__ + "img/20260624.3e17a83f.png";